/* src/app/intro/access-authority/access-authority.component.scss */
/*# sourceMappingURL=access-authority.component.css.map */
